import type { TaskItemDetail } from '@ordr-as/ordr-service-types/epos';
import ItemModifiers from './ItemModifiers';

/**
 * How loudly a card states its products. Work in hand is black and bold; work queued here is bold
 * but greyed; work still waiting on another station is greyed and lighter again, so a glance across
 * the board reads what to cook now without reading a single word.
 */
export type ItemEmphasis = 'ongoing' | 'queued' | 'waiting';

const EMPHASIS_CLASSES: Record<ItemEmphasis, string> = {
  ongoing: 'font-bold text-brand-black',
  queued: 'font-bold text-grey-dark',
  waiting: 'font-medium text-grey-dark',
};

type Props = {
  items: TaskItemDetail[];
  emphasis: ItemEmphasis;
  orderComment?: string | null;
};

const TaskCardItems = ({ items, emphasis, orderComment }: Props) => {
  const productClass = EMPHASIS_CLASSES[emphasis];

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => (
        <div key={item.id ?? index} className="flex flex-col gap-0.5">
          <div className="flex gap-2 items-baseline">
            <span className={`min-w-5 ${productClass}`}>{item.quantity ?? 1}×</span>
            <span className={`flex-1 ${productClass}`}>{item.itemName ?? 'Unknown item'}</span>
          </div>
          <ItemModifiers
            modifiers={(item.modifiers ?? []).map((m) => m.itemName ?? '').filter(Boolean)}
            comment={item.comment}
          />
        </div>
      ))}
      {orderComment && <div className="text-grey-dark">{orderComment}</div>}
    </div>
  );
};

export default TaskCardItems;
